import * as React from 'react'
import type { SVGProps } from 'react'
const SvgMagic = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m10.6069 17.7907.883-2.0118c.7725-1.778 2.1861-3.2035 3.9622-3.9957l2.4296-1.073c.7724-.3413.7724-1.4593 0-1.8016l-2.3532-1.039c-1.8219-.8128-3.2607-2.2907-4.0195-4.1288l-.8961-2.144a.947.947 0 0 0-.3498-.4335.955.955 0 0 0-1.0682 0 .948.948 0 0 0-.3499.4336l-.894 2.144c-.7588 1.838-2.1977 3.316-4.0196 4.1287l-2.3522 1.04c-.7723.3403-.7723 1.4593 0 1.8006l2.4287 1.073c1.7759.7919 3.1895 2.2171 3.9622 3.9947l.883 2.0118a.95.95 0 0 0 .3505.4216.9542.9542 0 0 0 1.0528 0 .945.945 0 0 0 .3505-.4206m8.8366 4.8985.2484-.5665a4.38 4.38 0 0 1 2.2335-2.2521l.7643-.3393a.533.533 0 0 0 .2261-.1957.529.529 0 0 0-.2261-.7682l-.721-.3193A4.38 4.38 0 0 1 19.703 15.92l-.2555-.6116a.507.507 0 0 0-.1875-.2322.512.512 0 0 0-.5723 0 .51.51 0 0 0-.1875.2322l-.2554.6106a4.382 4.382 0 0 1-2.2657 2.3291l-.7221.3203a.533.533 0 0 0-.2253.1958.5292.5292 0 0 0 .2253.7671l.7643.3383a4.379 4.379 0 0 1 2.2345 2.2531l.2484.5665c.1811.4144.7583.4144.9393 0"
    />
  </svg>
)
export default SvgMagic
